import { colors } from '@/common/helpers';
import {
  StyledBaselineReferenceIcon,
  StyledBaselineValue,
  StyledReferenceContainer,
  StyledReferenceText,
} from '../BarChart.styles';
import { TFunction } from 'i18next';
import { DateRangeOptionId } from '@/common/components';
import { BASELINE_COLOR_DEFAULT } from '../BarChart.types';

interface BaselineReferenceLabelProps {
  baseline?: number | null;
  baselinePeriod?: DateRangeOptionId;
  t: TFunction;
}

export const BaseLineReferenceLabel = ({
  baseline,
  baselinePeriod,
  t,
}: BaselineReferenceLabelProps): JSX.Element | null => {
  if (!baseline || !baselinePeriod) {
    return null;
  }

  return (
    <StyledReferenceContainer>
      <StyledBaselineReferenceIcon css={{ backgroundColor: `${colors?.baseline ?? BASELINE_COLOR_DEFAULT}` }} />
      <StyledReferenceText>
        {t('bar_chart.baseline_reference', { period: t(`bar_chart.period.${baselinePeriod}`) })}
      </StyledReferenceText>
      <StyledBaselineValue>{baseline ?? t('bar_chart.baseline_none_set')}</StyledBaselineValue>
    </StyledReferenceContainer>
  );
};
